var ko = require('knockout');
var cart = require('_components/organisms/shopping-cart/shopping-cart-storage');

var analytics = require('_js/analytics-ecommerce');
var APIHelper = require('_js/APIHelper');
var SearchPostalCode = require('_js/search-postal-code');

function GetDistinctParticipants(cart) {
  var participants = [].concat.apply(
    [],
    cart.courses.map(function(c) {
      return c.participants;
    })
  );

  var distinctParticipants = [];
  var unique = {};

  for (var i = 0; i < participants.length; i++) {
    var id = participants[i].AktorId;
    if (unique[id] === undefined) distinctParticipants.push(participants[i]);
    unique[id] = 0;
  }

  return distinctParticipants;
}

function MissingField(name, value, isEmailField) {
  this.name = name;

  var validationMethods = [
    { type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' }
  ];

  if (isEmailField)
    validationMethods.push({
      type: 'isEmail',
      message: 'Feltet må være en gyldig epostadresse'
    });

  this.value = ko.observable(value).extend({
    required: validationMethods
  });
}

function Model(params) {
  var self = this;
  self.isLoading = ko.observable(false);

  if (params.summaryUrl === undefined) throw 'summaryUrl must be defined';

  self.payerList = ko.observableArray([]);
  self.API = params.api;
  self.chosenPayerId = ko.observable();
  self.hideInLists = ko.observable(false);
  self.referenceNo = ko.observable('');
  self.errorMessage = ko.observable(params.errorMessage);

  self.backLink = params.backLink;
  self.texts = params.texts;

  // Used for validation of CRM fields.
  self.email = new MissingField('Epost', '', true);
  self.invoiceEmail = new MissingField('Fakturaepost', '', true);
  self.billingAddress = new MissingField('Fakturaadresse', '');
  self.billingPostCode = new MissingField('Postnummer', '');
  self.billingCity = new MissingField('Poststed', '');
  self.necessaryFields = [
    self.email,
    self.invoiceEmail,
    self.billingAddress,
    self.billingPostCode,
    self.billingCity
  ];

  self.missingFields = ko.observableArray([]);
  self.person = {};
  self.dataUpdated = ko.observable(false);
  // True while the chosen payer is fetched; missingFields is not reliable until then.
  self.isLoadingPayer = ko.observable(false);
  var payerRequestId = 0;

  self.validatePayer = function(el, ev) {
    var payerId = self.chosenPayerId();
    if (self.isLoadingPayer()) {
      ev.preventDefault();
      return false;
    }
    if (
      payerId === undefined ||
      payerId === '' ||
      self.missingFields().length > 0
    ) {
      if (self.missingFields().length > 0) {
        self.errorMessage(self.texts.missingPayerInfo);
      } else {
        self.errorMessage(self.texts.missingPayer);
      }
      ev.preventDefault();
      return false;
    }
    //Will redirect
    analytics.shoppingCartCheckedOut(3, cart.getCart(), params.summaryUrl);
  };

  var agency = cart.getCart().agency;
  var distinctParticipants = GetDistinctParticipants(cart.getCart());
  if (agency !== undefined && agency.AktorId !== '') {
    distinctParticipants.unshift(agency);
  }
  self.payerList(distinctParticipants);

  var setValidation = function(newValue) {
    for (var i = 0; i < self.necessaryFields.length; i++) {
      if (
        self.necessaryFields[i].value() === null ||
        self.necessaryFields[i].value().length === 0
      ) {
        self.necessaryFields[i].value.hasError(newValue);
      }
    }
  };

  var validateFields = function() {
    for (var i = 0; i < self.necessaryFields.length; i++) {
      if (
        self.necessaryFields[i].value() === null ||
        self.necessaryFields[i].value().length === 0 ||
        self.necessaryFields[i].value.hasError()
      ) {
        return false;
      }
    }
    return true;
  };

  self.updatePayerInformation = function() {
    self.isLoading(true);

    if (!validateFields()) {
      self.dataUpdated(false);
      setValidation(true);
      self.isLoading(false);
      return;
    }

    if (agency.AktorId === self.chosenPayerId()) {
      // Replace values in agency object with the ones used in the missing field.
      agency.Email = self.email.value();
      agency.InvoiceEmail = self.invoiceEmail.value();
      agency.BillingAddress = self.billingAddress.value();
      agency.BillingPostCode = self.billingPostCode.value();
      agency.BillingCity = self.billingCity.value();
      APIHelper.post(
        self.API.updateBillingInformationForAgency,
        agency,
        function() {
          self.missingFields([]);
          self.dataUpdated(true);
          self.isLoading(false);
          cart.updateAgency(agency);
        },
        function() {
          self.dataUpdated(false);
          self.isLoading(false);
        }
      );
    } else {
      self.person.Email = self.email.value();
      self.person.InvoiceEmail = self.invoiceEmail.value();
      self.person.BillingAddress = self.billingAddress.value();
      self.person.BillingPostCode = self.billingPostCode.value();
      self.person.BillingCity = self.billingCity.value();
      var personData = {
        AktorId: self.person.AktorId,
        Email: self.person.Email,
        InvoiceEmail: self.person.InvoiceEmail,
        BillingAddress: self.person.BillingAddress,
        BillingPostCode: self.person.BillingPostCode,
        BillingCity: self.person.BillingCity
      };

      APIHelper.QcPost(
        self.API.updateBillingInformationForEmployee,
        personData,
        function() {
          self.missingFields([]);
          self.dataUpdated(true);
          self.isLoading(false);
        },
        function() {
          self.dataUpdated(false);
          self.isLoading(false);
        }
      );
    }
  };

  var fillNecessaryFields = function(data) {
    self.email.value(data.Email);
    self.invoiceEmail.value(data.InvoiceEmail);
    self.billingAddress.value(data.BillingAddress);
    self.billingPostCode.value(data.BillingPostCode);
    self.billingCity.value(data.BillingCity);
  };

  var setMissingFields = function() {
    var tmpFields = [];
    for (var i = 0; i < self.necessaryFields.length; i++) {
      if (
        self.necessaryFields[i].value() === null ||
        self.necessaryFields[i].value().length === 0
      ) {
        tmpFields.push(self.necessaryFields[i]);
      }
    }
    self.missingFields(tmpFields);
  };

  var updatePayerInCart = function() {
    var payer = self.chosenPayerId();
    var hideInLists = self.hideInLists() || false;
    var referenceNo = self.referenceNo() || '';

    self.dataUpdated(false);
    self.missingFields([]);
    self.email.value('');
    self.invoiceEmail.value('');
    self.billingAddress.value('');
    self.billingCity.value('');
    self.billingPostCode.value('');
    setValidation(false);

    // Ignore responses for a payer that is no longer chosen.
    var requestId = ++payerRequestId;
    self.isLoadingPayer(false);

    if (agency.AktorId === payer) {
      fillNecessaryFields(agency);
      setMissingFields();
    } else if (payer !== null && payer !== undefined) {
      self.isLoadingPayer(true);
      APIHelper.get(
        self.API.getEmployee + '?aktorId=' + payer,
        function(data) {
          if (requestId !== payerRequestId) return;
          fillNecessaryFields(data);
          setMissingFields();
          self.person = JSON.parse(JSON.stringify(data));
          self.isLoadingPayer(false);
        },
        function() {
          if (requestId !== payerRequestId) return;
          // Could not verify the payer, so require all fields to be filled in.
          self.person = { AktorId: payer };
          setMissingFields();
          self.isLoadingPayer(false);
        }
      );
    }

    if (self.missingFields().length === 0) {
      $('#common-error-message').addClass('hidden');
    }

    cart.replacePayer({
      AktorId: payer,
      HideInLists: hideInLists,
      ReferenceNo: referenceNo
    });
  };

  var searchPostalCode = new SearchPostalCode(null, self.billingCity.value);

  self.billingPostCode.value.subscribe(function(val) {
    searchPostalCode.searchForCity(val);
  });

  self.chosenPayerId.subscribe(updatePayerInCart);
  self.hideInLists.subscribe(updatePayerInCart);
  self.referenceNo.subscribe(updatePayerInCart);

  var currentPayer = cart.getCart().payer;
  if (currentPayer !== undefined) {
    self.chosenPayerId(currentPayer.AktorId);
    self.hideInLists(currentPayer.HideInLists);
    self.referenceNo(currentPayer.ReferenceNo);
  }
}

module.exports = Model;
